import styled from "styled-components";

export const H2 = styled.h2`
  font-size: 34px;
  font-weight: 500;
  color: #565656;
`;
